import produce from 'immer';

import { VerificationCheckConfiguration } from 'dashboard/forms/FormVerificationTemplateChecks/FormVerificationTemplateChecks';
import { ExpirationCheckConfig } from 'dashboard/models/verification-check-config/id-expiration-detection';
import { indexForOverride } from 'dashboard/models/verification-check-config/utils';
import { VerificationCheckConfig } from 'dashboard/models/verification-check-config/verification-check-config';
import Input from 'design-system/components/Input';

interface ExpiredDetectionConfigurationElementProps {
  checkConfig: ExpirationCheckConfig;
  editable: boolean;
  handleUpdateCheck: (check: VerificationCheckConfig) => void;
}

const ExpiredDetectionConfigurationElement = ({
  checkConfig,
  editable,
  handleUpdateCheck,
}: ExpiredDetectionConfigurationElementProps) => {
  const overrideIndex = indexForOverride({
    attributesField: checkConfig['expiration-thresholds'],
    countryCode: 'default',
    idClass: 'default',
  });

  const updateExpirationThreshold = (expirationThresholdDays: number) => {
    const check = produce(checkConfig, (draft) => {
      draft['expiration-thresholds'][overrideIndex]['expiration-threshold-days'] =
        expirationThresholdDays;
    });
    handleUpdateCheck(check);
  };
  const expirationThreshold =
    checkConfig['expiration-thresholds'][overrideIndex]['expiration-threshold-days'];

  return (
    <VerificationCheckConfiguration
      title='Default Expiration Threshold (Days)'
      disabled={!editable}
      helpText='This is the default grace period for accepting expired IDs. Any countries that do not have custom expiration thresholds set in the enabled countries and ID types table will use this default expiration threshold'
    >
      <Input
        size='md'
        type='number'
        disabled={!editable}
        value={expirationThreshold}
        onChange={(e) => updateExpirationThreshold(+e.target.value)}
        placeholder='No default expiration threshold set'
      />
    </VerificationCheckConfiguration>
  );
};

export default ExpiredDetectionConfigurationElement;
